import React, { createContext, useContext, useState, useEffect } from 'react';

const ThemeSwitcher = createContext();

export const ThemeSwitcherProvider = ({ children }) => {
    // define state darkMode
    const [darkMode, setDarkMode] = useState(() => {
        // Check localStorage on initial load
        if (typeof window !== 'undefined') {
            return localStorage.getItem('darkMode') === 'true';
        }
        return false;
    });

    useEffect(() => {
        const root = document.documentElement;

        // Add transition class to prevent flash
        root.classList.add('no-transition');

        if (darkMode) {
            root.classList.add('dark');
        } else {
            root.classList.remove('dark');
        }

        // Remove transition class after a short delay
        setTimeout(() => {
            root.classList.remove('no-transition');
        }, 100);

        // Save to localStorage
        localStorage.setItem('darkMode', darkMode.toString());
    }, [darkMode]);

    const themeSwitcher = () => setDarkMode(!darkMode);

    return (
        <ThemeSwitcher.Provider value={{ darkMode, themeSwitcher }}>
            {children}
        </ThemeSwitcher.Provider>
    )
}

export const useTheme = () => useContext(ThemeSwitcher);
